import type { Box } from 'graphql-models';
import type { Factory } from './helpers';

const MOCK_BOX: Box = {
  id: '1',
  reportedLocked: true,
  reportedPin: '121344',
  deviceId: '123',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  reportedClosed: false,
  reportedFirmwareVersion: '1.0',
  reportedState: 'ACTIVE',
};

export const boxFactory: Factory<Box> = (overrides) => ({
  ...MOCK_BOX,
  ...overrides,
});
